import React from 'react';
import PropTypes from 'prop-types';
import Chart from "react-apexcharts";
import Card, {
    CardPrimaryContent,
    // CardMedia,
    // CardActions,
    // CardActionButtons,
    // CardActionIcons
  } from "@material/react-card";

import './RankAndMagnitude.scss';

const RankAndMagnitudeChart = ({xvalues, yvalues, yAxisTitle, handleSelectedDatapoint, selectedRankedItem, children, className, chartHeight, colors, isProportionValues}) => {
    // console.dir(yvalues)
    // console.dir(xvalues);
    // console.dir(colors)
    // console.log(yAxisTitle)
    //const height = '350px';
    let heightStyle = {
        height : chartHeight,
    }
    let chart = <div style={heightStyle}>No Data Available</div>
    // console.log(selectedRankedItem)
    const options = selectedRankedItem === "" ? _getOptions(xvalues, handleSelectedDatapoint, colors, isProportionValues ? '%' : '') : 
                                                _updateOptions(xvalues,  handleSelectedDatapoint, selectedRankedItem, isProportionValues ? '%' : '')
    
   // let series = []
    const series = _getSeries(yvalues, yAxisTitle)

    if (yvalues.length > 1 && yvalues[0] !== -1) {
        // series = _getSeries(yvalues, yAxisTitle)
        chart =   <Chart
                options={options}
                series={series}
                type="bar"
                width="100%"
                height={chartHeight}
            />
    }
   // console.dir(options)
    
    return (
            
            <div className={"bar-chart " + className} >
                {/* <ul className="rankAndMagnitudeChart-items">
                    {xvalues.map(xvalue=><li>{xvalue}</li>)}
                </ul> */}
                <Card  className="content">
                    <CardPrimaryContent>
                        {children}
                        {chart}
                        {/* <Chart
                            options={options}
                            series={series}
                            type="bar"
                            width="100%"
                            height={chartHeight}
                        /> */}
                    </CardPrimaryContent>
                </Card>
             </div>
  )
}

const _updateOptions = (usageCategories, handleSelectedDatapoint, selectedRankedItem, unit) => {
  //  console.log('updating')
    let colors = [];
    for (let i = 0; i < usageCategories.length; ++i) {
        colors.push('#eee')
    }
    
   const rankedItem = selectedRankedItem.substr(3)   
   const idx = usageCategories.findIndex((category)=>{
        return category.includes(rankedItem)
    })
    // const idx = usageCategories.indexOf(categy)
    if (idx > -1) {
       colors[idx] = '#ff0266'        
    }
     
    const options = _getOptions(usageCategories, handleSelectedDatapoint, selectedRankedItem, unit);
    let updatedOptions = {...options, colors}
    return updatedOptions
}

const _getSeries = (dataToPlot, name='frequency') => {
   
    const series = [
          {
            name: name,
            data: dataToPlot
          }
        ]

    return series;
}


const _getOptions = (usageCategories, handleSelectedDatapoint, colors, unit = '')=> {
      
    const options = {
            plotOptions: {
                bar: {
                    horizontal: true,
                    distributed: true
                }
            },
            stroke: {
                show: true,
                lineCap: 'round'
            },
            chart: {
              id: "basic-bar",
              events: {
                dataPointSelection: function(event, chartContext, config) {
                //   console.dir(chartContext)
                  console.dir(usageCategories[config.dataPointIndex])
                  handleSelectedDatapoint(usageCategories[config.dataPointIndex])
                }
              }
            },
            colors: colors,
            tooltip: {
                enabled: true,
                theme: 'dark'
            },
            dataLabels: {
                style: {
                    fontSize: '16px',
                    fontFamily: 'Rubik, Arial, sans-serif',
                    cssClass: 'apex-datalabels',
                    colors: ['#000']
                },
                formatter: (value) => { return value + unit }

            },
            // title: {
            //     text: 'Do you care about data? Here is a survey conducted with data visualization professionals who responded to how often people use their data visualizations',
            //     align: 'center',
            //     margin: 10,
            //     offsetX: 0,
            //     offsetY: 0,
            //     floating: false,
            //     style: {
            //       fontSize:  '34px',
            //       color:  '#000',
            //       cssClass: 'apex-title'
            //     },
            // },
            xaxis: {
              
              categories: usageCategories,
              border: {
                  show: false
              },
              title: {
                text: "Respondents",
                rotate: -90,
                offsetX: 0,
                offsetY: 0,
                style: {
                  //  color: undefined,
                    fontSize: '16px',
                    fontFamily: 'Rubik, Arial, sans-serif',
                    cssClass: 'apexcharts-yaxis-title',
                },
               },
               labels: {
                show: false,
                align: 'right',
                minWidth: 0,
                maxWidth: 160,
                style: {
                    color: undefined,
                    fontSize: '16px',
                    fontFamily: 'Rubik, Arial, sans-serif',
                    cssClass: 'apexcharts-xaxis-label',
                },
               
                offsetX: 0,
                offsetY: 0,
                rotate: 0,
                formatter: (value) => { return value },
              },
              floating: true,
              axisTicks: {
                show: false
              },
              axisBorder: {
                show: false
              },
            },
            yaxis: {
                
                labels: {
                    show: true,
                    align: 'right',
                    minWidth: 0,
                    maxWidth: 160,
                    style: {
                        color: undefined,
                        fontSize: '16px',
                        fontFamily: 'Rubik, Arial, sans-serif',
                        cssClass: 'apexcharts-yaxis-label',
                    },
                    offsetX: -10,
                    offsetY: 0,
                    rotate: 0,
                    formatter: (value) => { return value },
                  },
            }
        }

      return options;
}

RankAndMagnitudeChart.propTypes = {
    xvalues: PropTypes.array.isRequired,
    yvalues: PropTypes.array.isRequired, 
    colors: PropTypes.array.isRequired,
    yAxisTitle: PropTypes.string.isRequired
}

export default RankAndMagnitudeChart